import { Spinner } from "flowbite-react";
import React from "react";

interface LoadingProps {
  isLoading: boolean;
}
export default function Loading({ isLoading }: LoadingProps) {
  return isLoading ? <Spinner size={"xl"} /> : null;
}
